(function () {

  'use strict';

  function pxTreeFile() {
    return {
      require: '^^pxSitesTree',
      restrict: 'E',
      scope: {
        item: '='
      },
      templateUrl: 'app/components/sites/sitesTree/treeParts/treeFile.template.html',
      link: function (scope, element, attrs, sitesTreeCtrl) {
        scope.sitesTreeCtrl = sitesTreeCtrl;
      }
    };
  }

  pxTreeFile.$inject = [];

  angular
    .module('printix-admin')
    .directive('pxTreeFile', pxTreeFile);

})();
